<template>
  <div class="d-flex flex-column">
    <v-btn color="primary" text @click="exportEvaluationsToPDF" class="text-none justify-start" :loading="isExporting" :disabled="isExporting" style="width: 100%;">
      <v-icon left>mdi-file-pdf-box</v-icon>
      XUẤT ĐÁNH GIÁ PDF KIỂU RIÊNG LẺ
    </v-btn>
    <v-btn color="primary" text @click="exportAllEvaluationsToPDF" class="text-none justify-start" :loading="isExporting" :disabled="isExporting" style="width: 100%;">
      <v-icon left>mdi-file-pdf-box</v-icon>
      XUẤT ĐÁNH GIÁ PDF KIỂU TỔNG HỢP
    </v-btn>
  </div>
  <!-- <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" elevation="0" :loading="isExporting" :disabled="isExporting">
        <v-icon left>mdi-file-pdf-box</v-icon>
        Xuất đánh giá PDF
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="exportEvaluationsToPDF">
        <v-list-item-title>Xuất riêng lẻ</v-list-item-title>
      </v-list-item>
      <v-list-item @click="exportAllEvaluationsToPDF">
        <v-list-item-title>Xuất tổng hợp</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu> -->
</template>

<script>
import { mapState, mapActions } from 'vuex'
import jsPDF from 'jspdf'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import 'jspdf-autotable'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  components: {BaseBodyDialog},
  props: {
    evaluateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExporting: false,
      teachers: [],
      dialog: false
    }
  },
  computed: {
    ...mapState('evaluateStudent', ['evaluateStudents']),
  },
  methods: {
    ...mapActions('evaluateStudent', ['fetchEvaluateStudents']),
    ...mapActions('teachers', ['fetchTeachers']),
    async exportEvaluationsToPDF() {
      this.isExporting = true
      try {
        await this.fetchEvaluateStudents({ evaluate: this.evaluateId })
        this.teachers = await this.fetchTeachers()
        if (!this.evaluateStudents || this.evaluateStudents.length === 0) {
          this.$alert.error('Chưa có dữ liệu học sinh để xuất báo cáo.')
          return
        }

        const zip = new JSZip()

        for (const student of this.evaluateStudents) {
          student.lesson.teachers = this.teachers.filter((teacher) =>
            student.lesson.teachers.some((t) => t === teacher.id)
          )
          const pdf = await this.generateStudentPDF(student)
          const pdfBlob = pdf.output('blob')
          zip.file(`${student.student.name}_bao_cao_danh_gia.pdf`, pdfBlob)
        }

        const zipBlob = await zip.generateAsync({ type: 'blob' })
        if (zipBlob.size === 0) {
          throw new Error('Không thể tạo file ZIP')
        }
        saveAs(zipBlob, 'bao_cao_danh_gia_hoc_sinh.zip')
      } catch (error) {
        console.error(error)
        this.$alert.error({
          text: `Có lỗi xảy ra khi xuất báo cáo đánh giá: ${error.message}`,
          type: 'error',
        })
      } finally {
        this.isExporting = false
      }
    },

    async exportAllEvaluationsToPDF() {
      this.isExporting = true
      try {
        await this.fetchEvaluateStudents({ evaluate: this.evaluateId })
        this.teachers = await this.fetchTeachers()
        if (!this.evaluateStudents || this.evaluateStudents.length === 0) {
          this.$alert.error('Chưa có dữ liệu học sinh để xuất báo cáo.')
          return
        }

        const pdf = new jsPDF()

        for (let i = 0; i < this.evaluateStudents.length; i++) {
          const student = this.evaluateStudents[i]
          if (i > 0) {
            pdf.addPage()
          }
          await this.addStudentReportToPDF(pdf, student)
        }

        pdf.save('bao_cao_danh_gia_tong_hop.pdf')
      } catch (error) {
        console.error(error)
        this.$alert.error({
          text: `Có lỗi xảy ra khi xuất báo cáo đánh giá tổng hợp: ${error.message}`,
          type: 'error',
        })
      } finally {
        this.isExporting = false
      }
    },

    async generateStudentPDF(student) {
      const pdf = new jsPDF()
      await this.addStudentReportToPDF(pdf, student)
      return pdf
    },

    async addStudentReportToPDF(pdf, student) {
      // Add Vietnamese font
      pdf.addFont(
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        'Roboto',
        'normal'
      )
      pdf.setFont('Roboto')

      // Add header
      pdf.setFillColor(52, 152, 219) // Blue color
      pdf.rect(0, 0, 210, 40, 'F')
      pdf.setTextColor(255, 255, 255) // White color
      pdf.setFontSize(24)
      pdf.text(`BÁO CÁO HỌC TẬP`, 105, 25, null, null, 'center')

      // Add logo with correct aspect ratio
      // const logoWidth = 30
      // const logoHeight = 30
      // pdf.addImage(
      //   'https://online-learning-izteach-4-aws-source-bucket.s3.ap-southeast-1.amazonaws.com/prod/logo-th.png',
      //   'PNG',
      //   10,
      //   5,
      //   logoWidth,
      //   logoHeight
      // )

      // Add student information
      pdf.setTextColor(0, 0, 0) // Black color
      pdf.setFontSize(12)
      pdf.text(`HỌ TÊN HỌC SINH:`, 20, 50)
      pdf.text(`BUỔI HỌC:`, 20, 60)
      pdf.text(`THỜI GIAN:`, 20, 70)
      pdf.text(`LỚP:`, 20, 80)
      pdf.text(`GIÁO VIÊN:`, 20, 90)
      // pdf.text(`TRỢ GIẢNG:`, 20, 100)
      pdf.text(student.student.name, 80, 50)
      pdf.text(new Date(student.lesson.date).toLocaleDateString('vi-VN'), 80, 60)
      pdf.text(student.lesson.startTime, 80, 70)
      pdf.text(student.class.title, 80, 80)
      pdf.text(student.lesson.teachers.map((teacher) => teacher.name).join(', '), 80, 90)
      // pdf.text('...', 80, 100)

      // Add a decorative line
      pdf.setDrawColor(52, 152, 219)
      pdf.setLineWidth(0.5)
      pdf.line(20, 100, 190, 100)

      // Add evaluation table
      const tableData = student.evaluate_criteria.map((evaluation) => {
        const value = student.value.find((v) => v.id === evaluation._id)
        let displayValue = value ? value.value : 'Chưa đánh giá'
        if (Array.isArray(displayValue)) {
          displayValue = displayValue.join(', ')
        }
        return [evaluation.title, displayValue]
      })

      pdf.autoTable({
        startY: 110,
        head: [['TIÊU CHÍ', 'ĐÁNH GIÁ']],
        body: tableData,
        theme: 'striped',
        headStyles: { fillColor: [52, 152, 219], textColor: 255, font: 'Roboto', fontStyle: 'bold' },
        bodyStyles: { font: 'Roboto' },
        alternateRowStyles: { fillColor: [240, 240, 240] },
        styles: { font: 'Roboto', cellPadding: 5 },
        columnStyles: {
          0: { cellWidth: 100 },
          1: { cellWidth: 'auto' },
        },
      })

      // Add notes
      if (student.evaluate && student.evaluate.notes) {
        const finalY = pdf.lastAutoTable.finalY || 110
        pdf.setFontSize(12)
        pdf.setFont('Roboto', 'normal')
        pdf.text('GHI CHÚ:', 20, finalY + 20)
        pdf.setFont('Roboto', 'normal')
        pdf.setFontSize(10)
        const splitNotes = pdf.splitTextToSize(student.evaluate.notes, 170)
        pdf.text(splitNotes, 20, finalY + 30)
      }

      // Add footer
      const pageCount = pdf.internal.getNumberOfPages()
      pdf.setFontSize(10)
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i)
        pdf.setTextColor(100, 100, 100) // Gray color
        pdf.text(`Trang ${i} / ${pageCount}`, pdf.internal.pageSize.width - 30, pdf.internal.pageSize.height - 10)
        pdf.text(
          `© ${new Date().getFullYear()} Hệ thống Quản lý Đánh giá Học sinh`,
          20,
          pdf.internal.pageSize.height - 10
        )
      }
    },
  },
}
</script>
